import { Well } from '@zendeskgarden/react-notifications';
import type { PropsWell } from './interface';

export function WellBox({ content }: PropsWell) {
  return <Well isFloating>{content}</Well>;
}
